import { KNISTR_RED } from "./ImsMaterialTheme";

interface RedDotProps extends React.HTMLAttributes<HTMLDivElement> {}

const RedDot = ({ style, ...rest } : RedDotProps) => {
  return (
    <div
      {...rest}
      style={{
        backgroundColor: KNISTR_RED,
        borderRadius: "50%",
        width: "16px",
        height: "16px",
        display: "inline-block",
        ...style, // Merge custom styles with default styles
      }}
    />
  );
};

export { RedDot };